
export const editMutations = <const>{
	OZAKAZKA_VSTUP_PRAC_SELECT_MAPPER: 'OZAKAZKA_VSTUP_PRAC_SELECT_MAPPER',
	OZAKAZKA_LAK_DRUH_SELECT_MAPPER: 'OZAKAZKA_LAK_DRUH_SELECT_MAPPER',
	SAVE_OZAKAZKA_AFTER_MERGE: 'SAVE_OZAKAZKA_AFTER_MERGE',
	OZAKAZKA_VOZIDLO_SELECT_MAPPER: 'OZAKAZKA_VOZIDLO_SELECT_MAPPER',
	OZAKAZKA_ZAKAZNIK_SELECT_MAPPER: 'OZAKAZKA_ZAKAZNIK_SELECT_MAPPER',
	OZAKAZKA_ZAKAZNIK_FIRST_VISIT: 'OZAKAZKA_ZAKAZNIK_FIRST_VISIT',
	SERVICE_PACKAGE: 'SERVICE_PACKAGE',
	VOZIDLO_RIDIC_MAPPER: 'VOZIDLO_RIDIC_MAPPER',
};
export const listMutations = <const>{
	OZAKAZKA_LIST_NR_SELECT_MAPPER: 'OZAKAZKA_LIST_NR_SELECT_MAPPER',
	OZAKAZKA_LIST_ZAKAZNIK_SELECT_MAPPER: 'OZAKAZKA_LIST_ZAKAZNIK_SELECT_MAPPER',
	OZAKAZKA_LIST_VSTUP_PRAC_SELECT_MAPPER: 'OZAKAZKA_LIST_VSTUP_PRAC_SELECT_MAPPER',
	SET_FOLLOWUP_DATE_FLAG: 'setFollowupDateFlag',
};
export const actions = <const>{
	ZAKAZNIK_CHANGE: 'OZAKAZKA_ZAKAZNIK_CHANGE',
	VOZIDLO_CHANGE: 'OZAKAZKA_VOZIDLO_CHANGE',
	CREATE_ZAKAZKA: 'createZakazka',
	ZAKAZNICKA_SKUPINA_CHANGE: 'zakaznickaSkupinaChange',
	FAKTURACNI_PROFIL_CHANGE: 'fakturacniProfilChange',
	GET_VOZIDLO: 'GET_VOZIDLO',
	ORDER_SUBTYPE_CHANGE: 'orderSubTypeChange',
	SERVICE_JOB_CHANGE: 'serviceJobChange',
};
export const listActions = <const>{
	CHECK_FOLLOWUP_DATE: 'CheckForFollowUpDate',
};

export const types = <const>{
	mutations: {
		SERVICE_PACKAGE: 'SERVICE_PACKAGE',
		VOZIDLO_RIDIC_MAPPER: 'VOZIDLO_RIDIC_MAPPER',
		COMPUTE_ROWS_HASH: 'COMPUTE_ROWS_HASH',
		GET_CUSTOMER_CAMPAIGN_DETAILS : 'GET_CUSTOMER_CAMPAIGN_DETAILS',
	},
	actions: {
		ROZSIRENI_ZAK_LIST: 'rozsireniZakList',
		TISK_ZAK_LIST: 'tiskZakList',
		GET_RPZV_LOG: 'getRpzvLog',
		GET_CAMPAIGN_DETAILS: 'GET_CAMPAIGN_DETAILS',
	},
};

export type ElsaRExternalUrls = { App: string, Available: Boolean, Url: string };
